export default __webpack_public_path__ + "static/media/slot7.b0766255.png";